var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',_vm._b({staticClass:"settings-section",attrs:{"component":_vm.component}},'Card',_vm.$attrs,false),[_c('CardText',[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.actions)?_c('CardActions',{attrs:{"align":"left"}},[_vm._t("actions")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }